import React, { Component } from "react";
import { PageHeader } from "antd";
import { SettingOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { ButtonItem } from "../../../Components/Items";
import BandejaWhatsapp from "./Components/Chat/BandejaWhatsapp";
import VistaConfiguracion from "./Components/VistaConfiguracion";
import { WA } from "./theme";

class Whatsapp extends Component {
  state = {
    vista: "chat", // "chat" | "configuracion"
  };

  irAConfiguracion = () => this.setState({ vista: "configuracion" });
  volverAlChat = () => this.setState({ vista: "chat" });

  render() {
    const { vista } = this.state;
    const enConfig = vista === "configuracion";
    const puedeAsignar =
      this.props.permisoAsignarWhatsapp && !this.props.numeroPorUsuario;

    return (
      <>
        <PageHeader
          onBack={enConfig ? this.volverAlChat : undefined}
          avatar={{
            icon: <WhatsAppOutlined />,
            style: { backgroundColor: WA.lima, color: "#fff" },
          }}
          title={
            <span style={{ color: WA.lima }}>
              {enConfig ? "Configuración de Whatsapp" : "Whatsapp"}
            </span>
          }
          style={{
            border: `1px solid ${WA.border}`,
            borderTop: `3px solid ${WA.lima}`,
            borderRadius: 12,
            backgroundColor: WA.surface,
            marginBottom: 10,
          }}
          extra={
            enConfig ? null : this.props.permisoConfiguracionWhatsapp ||
              puedeAsignar ||
              this.props.permisoElementosWhatsapp ||
              this.props.permisoPlantillasWhatsapp ? (
              <ButtonItem
                className="botonAgregar"
                lima
                icon={<SettingOutlined />}
                onClick={this.irAConfiguracion}
              >
                Configuración
              </ButtonItem>
            ) : null
          }
        />

        {enConfig ? (
          <VistaConfiguracion
            headersToken={this.props.headersToken}
            empresaId={this.props.empresaId}
            puedeConfigurar={this.props.permisoConfiguracionWhatsapp}
            puedeAsignar={puedeAsignar}
            puedeElementos={this.props.permisoElementosWhatsapp}
            puedePlantillas={this.props.permisoPlantillasWhatsapp}
            puedeMarcarPrincipal={this.props.permisoMarcarPrincipal}
          />
        ) : (
          <BandejaWhatsapp
            headersToken={this.props.headersToken}
            empresaId={this.props.empresaId}
            permisoConfiguracionWhatsapp={
              this.props.permisoConfiguracionWhatsapp
            }
            permisoElementosWhatsapp={this.props.permisoElementosWhatsapp}
            permisoGuardarImagenInsumo={this.props.permisoGuardarImagenInsumo}
            permisoMensajeMasivo={this.props.permisoMensajeMasivo}
            permisoVerChatsOtros={this.props.permisoVerChatsOtros}
            permisoContestarChatsOtros={this.props.permisoContestarChatsOtros}
            permisoTraspasarChats={this.props.permisoTraspasarChats}
            onIrAConfiguracion={this.irAConfiguracion}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    numeroPorUsuario: state.empresa.whatsappNumeroPorUsuario,
    esMasterWhatsapp: state.user.tipo === 0,
    permisoConfiguracionWhatsapp:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a2d92d76b6fbe4192c21d05",
      )?.activado,
    permisoAsignarWhatsapp:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a304b14fa463f648899b770",
      )?.activado,
    permisoElementosWhatsapp:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a319b93047d1278102f2636",
      )?.activado,
    permisoPlantillasWhatsapp:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a319b15047d1278102f2548",
      )?.activado,
    // Permiso "Agregar imagen a Insumo" (#70).
    permisoGuardarImagenInsumo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a342cafe0b60690857dde2b",
      )?.activado,
    permisoVerChatsOtros:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6abfd0590f7d977af090185b",
      )?.activado,
    permisoContestarChatsOtros:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6abfd068c5542ea55e3949da",
      )?.activado,
    permisoTraspasarChats:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6abfd07b0f7d977af0901884",
      )?.activado,
    permisoMarcarPrincipal:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6abfd08c0f7d977af0901885",
      )?.activado,
    permisoMensajeMasivo:
      state.user.tipo === 0 ||
      state.user.permisos.find(
        (valueTodos) =>
          valueTodos.permisoId.toString() === "6a3afc9965cffab7b63b9b12",
      )?.activado,
  };
};

export default connect(mapStateToProps)(Whatsapp);
